import {
    FETCH_FORGET_SUCCESS,
    FETCH_LOGIN_SUCCESS
} from "./type";

import axios from "axios";
import { API_ENDPOINT } from '../../AppConfig';
import { hideLoading,showLoading } from 'react-redux-loading-bar';
import { showSnack } from 'react-redux-snackbar';

export let EmailBool = '';
export function SendingEmail(data, lang) {

    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/forgetPassword`;
        dispatch(showLoading());
        axios.post(uri, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                saveToLocalStorage('JazanEmail', data.email);
                dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'confirmationCode' });
                dispatch(showSnack('myUniqueId', {
                    label: lang === 'en' ? 'Please check your email' : 'من فضلك تفقد بريدك الالكتروني',
                    timeout: 7000
                }));
                dispatch(hideLoading());
                EmailBool = true;
            }).catch(error => {
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'E-mail': ' البريد الالكترونى' }
                    }));
                }
                else if (error.response.status === 404) {
                    EmailBool = false;
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'This email does not exsit' : 'البريد الالكترونى غير موجود',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'E-mail': ' البريد الالكترونى' }
                    }));
                }
            })
    }
}

export function ConfirmCode(data, lang) {
    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/confirmationCode`;
        dispatch(showLoading());

        axios.put(uri, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'resetPassword' });
                dispatch(hideLoading());
            }).catch(error => {
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'Sending code' : 'ارسال الكود ' }
                    }));
                }
                else if (error.response.status === 400) {
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'invalid code' : 'هذا الكود غير صحيح',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'Sending code' : 'ارسال الكود ' }
                    }));
                }
            })
    }
}

export function ResetPass(data, lang) {
    return (dispatch, getState) => {
        let uri = `${API_ENDPOINT}/confirmationchange`;
        dispatch(showLoading());

        axios.put(uri, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                saveToLocalStorage('JAZANtoken', JSON.stringify(response.data.user));
                saveToLocalStorage('JAZANtoken', JSON.stringify(response.data.token));
                dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'dashboard' });
                dispatch({ type: FETCH_LOGIN_SUCCESS, payload: response.data });
                dispatch(hideLoading());

            }).catch(error => {
                dispatch(hideLoading());
                if (!error.response) {
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'Reset password' : ' كلمة المرور الجديدة' }
                    }));
                }
            })
    }
}
export function resendCode(data) {
    return (dispatch, getState) => {
        dispatch({ type: FETCH_FORGET_SUCCESS, payload: 'email' });
    }
}
export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}
